import http from '../utils/http';

// 节目
const program = {
    /**
     * 节目列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @param {String} options.customerName 客户名称
     * @param {Number} options.pageNum 当前页
     * @param {Number} options.pageSize 每页条数
     * @returns Promise
     */
    programList(options = {}, config = {}) {
        return http.post('/program/list', options, {
            ...config
        })
    },

    /**
     * 节目保存
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#190
     * @param {Object} options
     * @returns Promise
     */
    saveProgram(options = {}, config = {}) {
        return http.post('/program/save', options, {
            // successMsg: true,
            showLoading: '保存中...',
            ...config,
        })
    },

    /**
     * 节目详情
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options
     * @returns Promise
     */
    programDetail(options = {}, config = {}) {
        return http.post('/program/getDetail', options, {
            ...config
        });
    },
    /**
     * 查看监播报表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options
     * @returns Promise
     */
    getEchart(options = {}, config = {}) {
        return http.post('/reportForms/programAverageExposureNum', options, {
            ...config
        });
    },
    /**
     * 查看节目统计
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options
     * @returns Promise
     */
    getStatisticsInfo(options = {}, config = {}) {
        return http.post('/program/getStatisticsInfo', options, {
            ...config
        });
    },

    /**
     * 节目投放区域（下拉框）
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options
     * @returns Promise
     */
    getDeviceGroupSelect(options = {}, config = {}) {
        return http.post('/program/getDeviceGroupSelect', options, {
            ...config
        });
    },

    deleteProgram(programVersion, config = {}) {
        return http.post('/program/delete', { programVersion }, {
            ...config
        });
    },

    /**
     * 节目发布
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#
     * @param {Object} options
     * @returns Promise
     */
    publishProgram(options, config = {}) {
        return http.post('/program/publish', options, {
            ...config
        });
    },

     /**
     * 追加设备-节目发布
     */
    appendDevice(options, config = {}) {
        return http.post('/program/appendDevice', options, {
            ...config
        });
    },

    /**
     * 节目下线
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#226
     * @param {Object} options
     * @returns Promise
     */
    offlineProgram(programVersion, config = {}) {
        return http.post('/program/offline', { programVersion }, {
            showLoading: '下线中...',
            successMsg: true,
            ...config
        });
    },

    /**
     * 节目投放区域（下拉框）
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#231
     * @param {Object} options
     * @returns Promise
     */
    copyProgram(programVersion, config = {}) {
        return http.post('/program/copy', { programVersion }, {
            showLoading: '复制中...',
            successMsg: true,
            ...config
        });
    },

    /**
     * 审批通过节目
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#210
     * @param {Object} options
     * @returns Promise
     */
    passPprogram(programVersion, config = {}) {
        return http.post('/program/auth', { programVersion, optType: 'PASS'  }, {
            showLoading: '审批中...',
            successMsg: false,
            ...config
        });
    },

    /**
     * 审批驳回节目
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#213
     * @param {Object} options
     * @returns Promise
     */
    rejectPprogram(programVersion, rejectReason, config = {}) {
        return http.post('/program/auth', { programVersion, rejectReason, optType: 'REJECT' }, {
            showLoading: '驳回中...',
            successMsg: false,
            ...config
        });
    },

    /**
     * 节目列表
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @param {String} options.customerName 客户名称
     * @param {Number} options.pageNum 当前页
     * @param {Number} options.pageSize 每页条数
     * @returns Promise
     */
    logList(options = {}) {
        return http.post('/programLog/list', options, {})
    },

    /**
    * 获取节目投放区域，下发详情，下载详情列表
    * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
    * @param {Object} options
    * @param {String} options.customerName 客户名称
    * @param {Number} options.pageNum 当前页
    * @param {Number} options.pageSize 每页条数
    * @returns Promise
    */
    putinDevicesByProgram(options = {}) {
        return http.post('/program/getPutinDevicesByProgram', options, {})
    },

    /**
     * 节目统计信息
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#218
     * @param {Object} options
     * @returns Promise
     */
    statisticsInfo(options = {}) {
        return http.post('/program/getStatisticsInfo', options, {})
    },

    /**
     * 检查节目名称是否重复
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#218
     * @param {Object} options
     * @returns Promise
     */
    checkName(options = {}) {
        return http.post('/program/checkName', options, {})
    },

    /**
     * 校验节目素材是否完整
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#218
     * @param {Object} options
     * @returns Promise
     */
    checkSource(options = {}) {
        return http.post('/program/checkSource', options, {})
    },
}

export default program;
